export { CostTableStalenessWarning } from './CostTableStalenessWarning.component';
